import { UpdateProjectVariantDocument } from '@/generated/graphql';
import { useMutation } from '@vue/apollo-composable';

export function useProjectVariantUpdate() {
    const updateVariantMutation = useMutation(UpdateProjectVariantDocument, {
        fetchPolicy: 'no-cache',
    });

    async function updateProjectVariantName(id: string, name: string, feedId: string) {
        const result = await updateVariantMutation.mutate({ id, name, feedId });
        return result;
    }

    return {
        updateProjectVariantName,
    };
}
